import { c as _c } from "react/compiler-runtime";
import './recent-activity-item.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.tsx';
import { TooltipInfo } from '@sola/ark-core/molecules/tooltip-info/tooltip-info.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { RecentActivityItemTracker } from './recent-activity-item-tracker.tsx';
import type { ActivityType } from './recent-activity-item.logic.ts';
import { getComponentRecentActivityItem } from './recent-activity-item.logic.ts';
export type RecentActivityItemProps = {
  title: string;
  direction: ActivityType;
  steps: string[];
  activeStepIndex: number;
  estimatedDelivery?: string;
  estimatedDeliveryTooltip?: string;
  message?: string;
  successHeading?: string;
  errorHeading?: string;
  ctaTitle?: string;
  cta?: () => void;
  ctaHref?: string;
};
export const RecentActivityItem: React.FC<RecentActivityItemProps> = t0 => {
  const $ = _c(51);
  const {
    title,
    direction,
    steps,
    activeStepIndex,
    estimatedDelivery,
    estimatedDeliveryTooltip,
    message,
    successHeading,
    errorHeading,
    ctaTitle,
    cta,
    ctaHref
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["core", "my"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== cta || $[2] !== ctaHref || $[3] !== ctaTitle || $[4] !== direction || $[5] !== errorHeading || $[6] !== estimatedDelivery || $[7] !== estimatedDeliveryTooltip || $[8] !== successHeading || $[9] !== t) {
    t2 = getComponentRecentActivityItem({
      direction,
      estimatedDelivery,
      estimatedDeliveryTooltip,
      successHeading,
      errorHeading,
      ctaTitle,
      cta,
      ctaHref,
      t
    });
    $[1] = cta;
    $[2] = ctaHref;
    $[3] = ctaTitle;
    $[4] = direction;
    $[5] = errorHeading;
    $[6] = estimatedDelivery;
    $[7] = estimatedDeliveryTooltip;
    $[8] = successHeading;
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const {
    isShowingDirection,
    directionLabel,
    directionIconName,
    iconBefore,
    isShowingEstimatedDelivery,
    isShowingTracker,
    isShowingCta
  } = t2;
  let t3;
  if ($[11] !== title) {
    t3 = <div className="RecentActivityItem__title label-potent label-lg label-neutral-amplified">{title}</div>;
    $[11] = title;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== directionIconName || $[14] !== directionLabel || $[15] !== estimatedDelivery || $[16] !== estimatedDeliveryTooltip || $[17] !== iconBefore || $[18] !== isShowingDirection || $[19] !== isShowingEstimatedDelivery) {
    t4 = (isShowingDirection || isShowingEstimatedDelivery) && <div className="flex w-full">{isShowingDirection && <div className="RecentActivityItem__direction flex flex-1 w-full items-center gap-snug-md">{iconBefore && <ArkIcon className="RecentActivityItem__icon" iconName={directionIconName} size="20px" />}<div className="label-potent label-md md:label-md md:label-potent">{directionLabel}</div>{!iconBefore && <ArkIcon className="RecentActivityItem__icon" iconName={directionIconName} size="20px" />}</div>}{isShowingEstimatedDelivery && <div className="RecentActivityItem__tooltip flex items-center gap-snug-md"><div className="label-mild label-md">{estimatedDelivery}</div><TooltipInfo contentClassName="label-md lg:label-lg" align="end" size="sm" alignOffset={-12} collisionPadding={16} usePortal={true}>{estimatedDeliveryTooltip}</TooltipInfo></div>}</div>;
    $[13] = directionIconName;
    $[14] = directionLabel;
    $[15] = estimatedDelivery;
    $[16] = estimatedDeliveryTooltip;
    $[17] = iconBefore;
    $[18] = isShowingDirection;
    $[19] = isShowingEstimatedDelivery;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== t3 || $[22] !== t4) {
    t5 = <div className="mb-comfy-sm">{t3}{t4}</div>;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== successHeading) {
    t6 = successHeading && <div className="RecentActivityItem__success label-potent label-md">{successHeading}</div>;
    $[24] = successHeading;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== errorHeading) {
    t7 = errorHeading && <div className="RecentActivityItem__error label-potent label-md mb-snug-sm">{errorHeading}</div>;
    $[26] = errorHeading;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== message) {
    t8 = message && <div className={cn("RecentActivityItem__message mb-snug-md label-mild label-md")}>{message}</div>;
    $[28] = message;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== activeStepIndex || $[31] !== isShowingTracker || $[32] !== steps) {
    t9 = isShowingTracker && <RecentActivityItemTracker steps={steps} activeStepIndex={activeStepIndex} />;
    $[30] = activeStepIndex;
    $[31] = isShowingTracker;
    $[32] = steps;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  let t10;
  if ($[34] !== ctaHref || $[35] !== ctaTitle || $[36] !== isShowingCta) {
    t10 = isShowingCta && ctaHref && <LinkStyle noUnderline={true} inline={true}><a className="mt-comfy-lg" href={ctaHref}>{ctaTitle}</a></LinkStyle>;
    $[34] = ctaHref;
    $[35] = ctaTitle;
    $[36] = isShowingCta;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== cta || $[39] !== ctaHref || $[40] !== ctaTitle || $[41] !== isShowingCta) {
    t11 = isShowingCta && !ctaHref && <LinkStyle noUnderline={true} inline={true}><button className="mt-comfy-lg" type="button" onClick={cta}>{ctaTitle}</button></LinkStyle>;
    $[38] = cta;
    $[39] = ctaHref;
    $[40] = ctaTitle;
    $[41] = isShowingCta;
    $[42] = t11;
  } else {
    t11 = $[42];
  }
  let t12;
  if ($[43] !== t10 || $[44] !== t11 || $[45] !== t5 || $[46] !== t6 || $[47] !== t7 || $[48] !== t8 || $[49] !== t9) {
    t12 = <div className="RecentActivityItem flex pt-comfy-sm p-comfy-lg rounded-md w-full relative"><div className="RecentActivityItem__content flex flex-1 flex-col">{t5}{t6}{t7}{t8}{t9}{t10}{t11}</div></div>;
    $[43] = t10;
    $[44] = t11;
    $[45] = t5;
    $[46] = t6;
    $[47] = t7;
    $[48] = t8;
    $[49] = t9;
    $[50] = t12;
  } else {
    t12 = $[50];
  }
  return t12;
};